import { useEffect } from 'react'
import OrganizationsContainer from '../components/Organizations/OrganizationsContainer'

export default function Organizations() {
  useEffect(() => {}, [])

  return <OrganizationsContainer />
}
